import { useEffect, useState } from "react";
import { requestGetStudentsEventReservation } from "services/events/attendance";
import useMainContext from "utils/context/useMainContext";

const useStudentReservations = ({
	goToEventList,
	loadingRequest,
	eventData,
}) => {
	const mainContext = useMainContext();
	const [studentReservations, setStudentReservations] = useState([]);
	const [studentReservationsBase, setStudentReservationsBase] = useState([]);
	const [attendanceAllStudents, setAttendaceAllStudents] = useState(false);
	useEffect(() => {
		if (!eventData.isLoaded) return;
		fillStudentsReservation();
	}, [eventData.isLoaded]);
	useEffect(() => {
		setAttendaceAllStudents(allStudentsHaveAttendance());
	}, [studentReservations]);
	async function fillStudentsReservation() {
		const data = eventData.value;
		if (!data) {
			goToEventList();
			return;
		}
		loadingRequest.show();
		try {
			const fetchStudentReservations =
				await requestGetStudentsEventReservation(data.dateEventId);
			setStudentReservationsBase(fetchStudentReservations);
			setStudentReservations(fetchStudentReservations);
		} catch (err) {
			mainContext.setShowDialogUnexpectedError(true);
		} finally {
			loadingRequest.hide();
		}
	}
	const allStudentsHaveAttendance = () => {
		return (
			studentReservations.length > 0 &&
			studentReservations.every(({ attendance }) => attendance)
		);
	};
	const someStudentsHaveAttendance = () => {
		return studentReservationsBase.some(({ attendance }) => attendance);
	};
	const noStudentsHaveAttendance = () => {
		return studentReservations.every(({ attendance }) => !attendance);
	};
	const studentExists = studentId => {
		return studentReservations.some(({ id }) => id === studentId.trim());
	};
	return {
		value: studentReservations,
		set: setStudentReservations,
		fill: fillStudentsReservation,
		someStudentsHaveAttendance,
		attendanceAllStudents,
		noStudentsHaveAttendance,
		exists: studentExists,
	};
};

export default useStudentReservations;
